import { ColWidth } from "@/constants/common.constant";
import { TableHeaderConfig } from "@/interfaces/common.interface";

export const tableConfig: TableHeaderConfig[] = [
  {
    prop: "mukoFlg",
    label: "無効",
    width: ColWidth.mini,
    class: "muko",
  },
  {
    prop: "kaishaCd",
    label: "会社コード",
    width: ColWidth.sm,
  },
  {
    prop: "kaishaNm",
    label: "会社名",
  },
  {
    prop: "unyoNm",
    label: "運用区分",
    width: ColWidth.sm,
  },
  {
    prop: "gyoushu",
    label: "業種分類",
  },
  {
    prop: "createdDate",
    label: "登録日時",
    width: ColWidth.lg,
  },
  {
    prop: "updatedDate",
    label: "更新日時",
    width: ColWidth.lg,
  },
];
